"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var InfiniteLoaderMobile_1 = require("./InfiniteLoaderMobile");
var InfiniteLoaderDesktop_1 = require("./InfiniteLoaderDesktop");
var InfiniteLoader = /** @class */ (function (_super) {
    __extends(InfiniteLoader, _super);
    function InfiniteLoader() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    InfiniteLoader.prototype.render = function () {
        var mobile = (typeof window !== 'undefined') && window.innerWidth < 768;
        return mobile ?
            React.createElement(InfiniteLoaderMobile_1.default, { text: this.props.text, customLoader: this.props.customLoader }) :
            React.createElement(InfiniteLoaderDesktop_1.default, { text: this.props.text, customLoader: this.props.customLoader });
    };
    return InfiniteLoader;
}(React.Component));
exports.default = InfiniteLoader;
//# sourceMappingURL=InfiniteLoader.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/login-ui/components/common/InfiniteLoader/InfiniteLoader.js
// module id = 1700
// module chunks = 8